import { render } from "./ShipmentList.vue?vue&type=template&id=5d0dc7e8&scoped=true"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"

import "./ShipmentList.vue?vue&type=style&index=0&id=5d0dc7e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0dc7e8"]])

export default __exports__